import InstagramViewer from './InstagramViewer'

export default InstagramViewer
